import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useInView } from 'react-intersection-observer';

function AboutSection() {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <div id="about" className="about-section py-5">
            <Container>
                <div ref={ref} className={`animate-about ${inView ? 'slide-up' : ''}`}>
                    <div className="text-start mb-5">
                        <h3 className="fw-bold" style={{ color: '#0a2240', letterSpacing: '1px' }}>HIGHLIGHTS</h3>
                        <h4 className="text-muted fw-normal" style={{ maxWidth: '800px', lineHeight: '1.6' }}>
                            A Dual-Asset Gold Platform Positioned For Significant Growth And Domestic Production
                        </h4>
                    </div>

                    {/* Strategic Pillars */}
                    <Row className="g-4 mb-5">
                        <Col md={6}>
                            <div className="strategic-pillar h-100 p-4 bg-white shadow-sm border border-light">
                                <div className="d-flex align-items-start gap-3">
                                    <div className="pillar-icon-wrapper flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '48px', height: '48px', backgroundColor: 'rgba(245, 200, 69, 0.15)' }}>
                                        <img src="/images/arrow.svg" alt="arrow" style={{ width: '20px' }} />
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-2" style={{ color: '#0a2240' }}>Transformational U.S. Gold Acquisition</h5>
                                        <p className="text-muted mb-0" style={{ lineHeight: '1.6' }}>
                                            Q-Gold has acquired the 2.010 Moz M&I Quartz Mountain project from Alamos Gold, who is retaining a 9% stake, validating the asset's potential and aligning long-term interests.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="strategic-pillar h-100 p-4 bg-white shadow-sm border border-light">
                                <div className="d-flex align-items-start gap-3">
                                    <div className="pillar-icon-wrapper flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '48px', height: '48px', backgroundColor: 'rgba(245, 200, 69, 0.15)' }}>
                                        <img src="/images/arrow.svg" alt="arrow" style={{ width: '20px' }} />
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-2" style={{ color: '#0a2240' }}>Mine Centre Exploration</h5>
                                        <p className="text-muted mb-0" style={{ lineHeight: '1.6' }}>
                                            2026 exploration targeted to define bulk mining potential at Mine Centre with field mapping, sampling trenching and selected drilling on over 60 veins outcropping at surface.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* PEA Bento Grid */}
                    <div className="pea-bento-grid mt-5 pt-4">
                    <div className="text-start mb-5">
                            <h4 className="fw-bold mb-2" style={{ color: '#0a2240' }}>Maiden Preliminary Economic Assessment <span className="text-muted" style={{ fontSize: '0.75rem', fontWeight: '400' }}>As of April 8, 2026</span></h4>
                        </div>

                        <Row className="g-4">
                            {/* Financials Base */}
                            <Col md={6}>
                                <div className="bento-card p-4 shadow-sm h-100 d-flex flex-column justify-content-between" style={{ backgroundColor: '#05244d', color: '#fff' }}>
                                    <div style={{ color: '#f5c845', fontSize: '0.85rem', fontWeight: '700', letterSpacing: '1px' }} className="mb-4">BASE CASE (US$3,265/oz)</div>
                                    <div className="d-flex justify-content-between align-items-end">
                                        <div>
                                            <div className="opacity-75 small fw-semibold mb-1">After-Tax NPV(5%)</div>
                                            <div className="fw-bold" style={{ fontSize: 'clamp(2rem, 4vw, 2.5rem)', lineHeight: '1' }}>US$1.71B</div>
                                        </div>
                                        <div className="text-end">
                                            <div className="opacity-75 small fw-semibold mb-1">After-Tax IRR</div>
                                            <div className="fw-bold" style={{ color: '#f5c845', fontSize: 'clamp(2rem, 4vw, 2.5rem)', lineHeight: '1' }}>55.2%</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            {/* Financials Spot */}
                            <Col md={6}>
                                <div className="bento-card p-4 shadow-sm h-100 d-flex flex-column justify-content-between" style={{ backgroundColor: '#0a2240', color: '#fff' }}>
                                    <div style={{ color: '#f5c845', fontSize: '0.85rem', fontWeight: '700', letterSpacing: '1px' }} className="mb-4">SPOT CASE (US$4,800/oz)</div>
                                    <div className="d-flex justify-content-between align-items-end">
                                        <div>
                                            <div className="opacity-75 small fw-semibold mb-1">After-Tax NPV(5%)</div>
                                            <div className="fw-bold" style={{ fontSize: 'clamp(2rem, 4vw, 2.5rem)', lineHeight: '1' }}>US$3.20B</div>
                                        </div>
                                        <div className="text-end">
                                            <div className="opacity-75 small fw-semibold mb-1">After-Tax IRR</div>
                                            <div className="fw-bold" style={{ color: '#f5c845', fontSize: 'clamp(2rem, 4vw, 2.5rem)', lineHeight: '1' }}>92%</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            {/* Costs */}
                            <Col lg={4}>
                                <div className="bento-card bg-white p-4 shadow-sm h-100 border border-light d-flex flex-column justify-content-between">
                                    <div className="text-muted fw-bold mb-4" style={{ fontSize: '0.85rem', letterSpacing: '1px' }}>COSTS & CAPITAL</div>
                                    <div>
                                        <div className="mb-4">
                                            <div className="fw-bold" style={{ color: '#0a2240', fontSize: '2rem', lineHeight: '1' }}>US$1,216<span className="fs-6 text-muted fw-normal">/oz</span></div>
                                            <div className="small text-muted mt-1 fw-medium">All-In Sustaining Cost (AISC)</div>
                                        </div>
                                        <div>
                                            <div className="fw-bold" style={{ color: '#0a2240', fontSize: '2rem', lineHeight: '1' }}>US$290M</div>
                                            <div className="small text-muted mt-1 fw-medium">Initial Capex (incl. $48M contingency)</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            {/* Production */}
                            <Col lg={4}>
                                <div className="bento-card bg-white p-4 shadow-sm h-100 border border-light d-flex flex-column justify-content-between">
                                    <div className="text-muted fw-bold mb-4" style={{ fontSize: '0.85rem', letterSpacing: '1px' }}>PRODUCTION PROFILE</div>
                                    <div>
                                        <div className="mb-4">
                                            <div className="fw-bold" style={{ color: '#0a2240', fontSize: '2.5rem', lineHeight: '1' }}>1.9M <span className="fs-5 text-muted fw-normal">oz</span></div>
                                            <div className="small text-muted mt-1 fw-medium">Life of Mine Gold Production</div>
                                        </div>
                                        <div className="d-flex justify-content-between border-top pt-3">
                                            <div>
                                                <div className="fw-bold fs-4" style={{ color: '#0a2240' }}>135k oz</div>
                                                <div className="small text-muted fw-medium">Annual Avg</div>
                                            </div>
                                            <div className="text-end border-start ps-3">
                                                <div className="fw-bold fs-4" style={{ color: '#0a2240' }}>14 yrs</div>
                                                <div className="small text-muted fw-medium">Mine Life</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            {/* Resource */}
                            <Col lg={4}>
                                <div className="bento-card p-4 shadow-sm h-100 d-flex flex-column justify-content-between" style={{ backgroundColor: '#f5c845', color: '#0a2240' }}>
                                    <div className="fw-bold mb-4 opacity-75" style={{ fontSize: '0.85rem', letterSpacing: '1px' }}>NI 43-101 RESOURCE</div>
                                    <div>
                                        <div className="mb-4">
                                            <div className="fw-bold" style={{ fontSize: '2.5rem', lineHeight: '1' }}>2.01M <span className="fs-5 fw-normal opacity-75">oz</span></div>
                                            <div className="small fw-bold mt-1 opacity-75">Indicated Category</div>
                                        </div>
                                        <div>
                                            <div className="fw-bold" style={{ fontSize: '2rem', lineHeight: '1' }}>494K <span className="fs-5 fw-normal opacity-75">oz</span></div>
                                            <div className="small fw-bold mt-1 opacity-75">Inferred Category</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default AboutSection;
